// Product lightbox: opens on the tapped image, one image per screen, with swipe, arrows and arrow keys.
// Works on top of Dawn's <product-modal>; see product-lightbox.css.
(function () {
  const ARROW = (d) =>
    `<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="${d}" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function setup(modal) {
    const track = modal.querySelector('.product-media-modal__content');
    const dialog = modal.querySelector('.product-media-modal__dialog');
    if (!track || !dialog || modal.dataset.lightbox) return;
    modal.dataset.lightbox = 'true';

    const slides = () => Array.from(track.children);
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'lightbox-nav lightbox-nav--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = ARROW('M10 3L5 8l5 5');
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'lightbox-nav lightbox-nav--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = ARROW('M6 3l5 5-5 5');
    const count = document.createElement('div');
    count.className = 'lightbox-count';
    count.setAttribute('aria-live', 'polite');
    dialog.append(prev, next, count);

    const update = () => {
      const total = slides().length;
      const i = Math.min(total - 1, Math.max(0, index()));
      modal.classList.toggle('product-media-modal--single', total < 2);
      count.textContent = `${i + 1} / ${total}`;
      prev.disabled = i === 0;
      next.disabled = i === total - 1;
    };
    const go = (step) => {
      track.scrollTo({ left: (index() + step) * track.clientWidth, behavior: 'smooth' });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });

    document.addEventListener('keydown', (e) => {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });

    // Back button / back swipe closes the viewer instead of leaving the page.
    let pushed = false;
    window.addEventListener('popstate', () => {
      if (pushed && modal.hasAttribute('open')) {
        pushed = false;
        modal.hide();
      }
    });

    // Dawn scrolls the tapped image into view on open; snap exactly to it once laid out.
    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) {
        if (pushed) {
          pushed = false;
          history.back();
        }
        return;
      }
      if (!pushed) {
        history.pushState({ lightbox: true }, '');
        pushed = true;
      }
      window.requestAnimationFrame(() => {
        const active = track.querySelector(':scope > .active');
        const i = Math.max(0, slides().indexOf(active));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'instant' });
        update();
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    update();
  }

  const init = () => document.querySelectorAll('product-modal').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
